import { Draggable } from 'react-beautiful-dnd';
import React from 'react';
import PollEntity from '../../../store/polls-store/poll-entity';
import Poll from '../polls-list-container/polls-list-item';
import { useStore } from './../../../store/store-provider';
import { observer } from 'mobx-react';
import { MIDDLE_SIZE_BREAKPOINT } from '../../../constans/responsive-break-points';

interface IProps {
  poll: PollEntity;
  index: number;
  selectPoll: (pollId: string) => void;
}

const DraggablePollWrapper: React.FC<IProps> = ({
  poll,
  index,
  selectPoll,
}): JSX.Element => {
  const { pollsStore, podiumInfoStore } = useStore();
  const pollId = poll.getId();
  const isSelected = pollId === pollsStore.selectedPollId;
  const isEllipsisMenuOpened = pollsStore.isEllipsisMenuOpened;
  const isMobile = podiumInfoStore.isResolutionBreakPointActive(MIDDLE_SIZE_BREAKPOINT);
  // Read these here (rather than inside the Draggable render-prop below) so mobx's observer tracks
  // them as dependencies of THIS component's render — reads inside the render-prop happen outside
  // the tracked scope and only pick up fresh values when something else forces a re-render.
  const isOnePollOpened = pollsStore.isOnePollOpened;
  const isSomePollResultsShared = pollsStore.isSomePollResultsShared;
  const isNextGenPlayer = pollsStore.isNextGenPlayer;

  const handleSelectPoll = (): void => {
    selectPoll(pollId);
  };

  return (
    <>
      <Draggable
        key={pollId}
        draggableId={pollId}
        index={index}
      >
        {(provided) => (
          <div onClick={handleSelectPoll} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <Poll
              poll={poll}
              isSelected={isSelected}
              isEllipsisMenuOpened={isEllipsisMenuOpened}
              setShouldShowEllipsisMenu={pollsStore.setShouldShowEllipsisMenu}
              toggleManagePollModal={pollsStore.toggleManagePollModal}
              setShouldShowDeleteModal={pollsStore.setShouldShowDeleteModal}
              setShouldShowResetModal={pollsStore.setShouldShowResetModal}
              setShouldShowAddResultsSlideModal={pollsStore.setShouldShowAddResultsSlideModal}
              changePollStatus={pollsStore.changePollStatus}
              setActiveMobileTab={pollsStore.setActiveTab}
              setIsOnePollOpened={pollsStore.setIsOnePollOpened}
              isOnePollOpened={isOnePollOpened}
              isSomePollResultsShared={isSomePollResultsShared}
              isNextGenPlayer={isNextGenPlayer}
              sharePollResults={pollsStore.sharePollResults}
              isMobile={isMobile}
            />
          </div>
        )}
      </Draggable>
    </>
  );
};

export default observer(DraggablePollWrapper);
